import * as React from "react";
import styled from "styled-components";
import Routes from "routing/Routes";
import { Icon, Link } from "components/common";
import { useStore } from "stores/connect";
import { NodesStore } from "stores/nodes/NodesStore";
import AppConfig from "util/AppConfig";
const BreakWord = styled.span`
  word-break: break-word;
`;
const NodeTitle = ({ shortNodeId, hostname }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { name: "lan" }), "\xA0", /* @__PURE__ */ React.createElement(BreakWord, null, shortNodeId), "\xA0/\xA0", /* @__PURE__ */ React.createElement(BreakWord, null, hostname));
const NodeName = ({ nodeId }) => {
  const node = useStore(NodesStore, (state) => {
    var _a;
    return (_a = state == null ? void 0 : state.nodes) == null ? void 0 : _a[nodeId];
  });
  if (!node) {
    return /* @__PURE__ */ React.createElement(BreakWord, null, "stopped node");
  }
  if (AppConfig.isCloud()) {
    return /* @__PURE__ */ React.createElement(NodeTitle, { shortNodeId: node.short_node_id, hostname: node.hostname });
  }
  return /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.CLUSTER.NODE_SHOW(nodeId), title: `Cluster node ${node.short_node_id} / ${node.hostname}` }, /* @__PURE__ */ React.createElement(NodeTitle, { shortNodeId: node.short_node_id, hostname: node.hostname }));
};
export default NodeName;
